import {atom} from "recoil";
import {
  BrandKitDto,
  DesignDto,
  LocationDto,
  MemberDtoPlanEnum,
  SquareRestaurantDto,
  ToastRestaurantDto,
  TreezRestaurantDto,
  PopmenuRestaurantDto, PermissionsDto, DashboardDtoStripePlanTypeEnum
} from "../generated/dashboard-client";
import {
  SquareUpdateByDesign,
  ToastUpdateByDesign,
  TreezUpdateByDesign,
  PopmenuUpdateByDesign, PlanType, PlanLength
} from "../util/types";
import { MemberDtoRoleEnum, PriceDto, SubStatusDto } from "../generated/dashboard-client";

export interface MemberState {
  id: string;
  internalId: number;
  teamId: string;
  logged: boolean;
  plan: MemberDtoPlanEnum;
  email: string;
  name: string;
  owner: boolean;
  role: string,
  oldLoginKey: string;
  printInvoicing: boolean;
  subscriptionInvoicing: boolean;
  downloads: boolean;
  printing: boolean;
  templates: boolean;
  permissions: { [key: string]: PermissionsDto; };
}

export interface CartState {
  menus: string[];
}

export const memberState = atom({
  key: "memberState",
  default: {
    id: "",
    teamId: "",
    internalId: 0,
    logged: false,
    plan: MemberDtoPlanEnum.Free as MemberDtoPlanEnum,
    email: "",
    name: "",
    owner: false,
    role: MemberDtoRoleEnum.User as MemberDtoRoleEnum,
    oldLoginKey: "",
    status: 0,
    ownerId: 0,
    dsaBeta: false,
    printInvoicing: false,
    subscriptionInvoicing: false,
    downloads: false,
    printing: false,
    templates: false,
    updateDrd: false,
    orderPrint: false,
    viewOnly: false,
    itemLibraryOnly: false,
    dataOnly: false,
    manageBrand: false,
    showItemLibrary: false,
    partner: "",
    permissions: {} as { [key: string]: PermissionsDto },
    stripePlanType: DashboardDtoStripePlanTypeEnum.Free as DashboardDtoStripePlanTypeEnum,
    diningRDIntegration: false,
    diningRDIntegrationPro: false,
    diningRDIntegrationDesign: false,
    enterpriseDisplayAccount: false,
  },
});

export const cartState = atom({
  key: "cartState",
  default: {
    menus: [] as string[]
  },
});

export const printProductionState = atom({
  key: "printProductionState",
  default: {
    menus: [] as string[]
  }
});

export const posState = atom({
  key: "posState",
  default: {
    enabled: false,
    toastEmail: "",
    isToast: false,
    isSquare: false,
    isTreez: false,
    isPopmenu: false,
  },
});

export const ceoLetterState = atom({
  key: "ceoLetterState",
  default: false
});

export const freePlanDiscontinuedState = atom({
  key: "freePlanDiscontinuedState",
  default: false
});

export const locationsState = atom({
  key: "locationsState",
  default: [] as LocationDto[],
});

export const brandKitsState = atom({
  key: "brandKitsState",
  default: [] as BrandKitDto[],
});

// Bumped whenever a DRD attribute->icon mapping changes, so every surface that displays it
// (Icons tab, Uploads tab, Asset Library) re-fetches and stays in sync.
export const drdIconMappingVersionState = atom({
  key: "drdIconMappingVersionState",
  default: 0,
});

export const toastRestaurantsState = atom({
  key: "toastRestaurantState",
  default: [] as ToastRestaurantDto[],
});

export const squareRestaurantsState = atom({
  key: "squareRestaurantsState",
  default: [] as SquareRestaurantDto[],
});

export const treezRestaurantsState = atom({
  key: "treezRestaurantsState",
  default: [] as TreezRestaurantDto[],
});

export const popmenuRestaurantsState = atom({
  key: "popmenuRestaurantsState",
  default: [] as PopmenuRestaurantDto[],
});

export const toastDeltaUpdatesState = atom({
  key: "toastDeltaUpdatesState",
  default: {} as ToastUpdateByDesign
});

export const squareDeltaUpdatesState = atom({
  key: "squareDeltaUpdatesState",
  default: {} as SquareUpdateByDesign
});

export const treezDeltaUpdatesState = atom({
  key: "treezDeltaUpdatesState",
  default: {} as TreezUpdateByDesign
});

export const popmenuDeltaUpdatesState = atom({
  key: "popmenuDeltaUpdatesState",
  default: {} as PopmenuUpdateByDesign
});

export const designUsingToastState = atom({
  key: "designUsingToastState",
  default: [] as DesignDto[]
});

export const designUsingSquareState = atom({
  key: "designUsingSquareState",
  default: [] as DesignDto[]
});

export const designUsingTreezState = atom({
  key: "designUsingTreezState",
  default: [] as DesignDto[]
});

export const designUsingPopmenuState = atom({
  key: "designUsingPopmenuState",
  default: [] as DesignDto[]
});

export const mobileState = atom({
  key: "mobileState",
  default: false
});

export const paymentJsLoadedState = atom({
  key: "paymentJsLoadedState",
  default: false
});

export const ilJsLoadedState = atom({
  key: "ilJsLoadedState",
  default: false
});

export const planTypeState = atom({
  key: "planTypeState",
  default: null as PlanType | null
});

export const planLengthState = atom({
  key: "planLengthState",
  default: 'annual' as PlanLength
});

export const regStepState = atom({
  key: "regStepState",
  default: 0
});

export const popmenuFlowState = atom({
  key: "popmenuFlowState",
  default: false
});

export const drdFlowState = atom({
  key: "drdFlowState",
  default: false
});

export const pricesState = atom({
  key: "pricesState",
  default: [] as PriceDto[]
})

export const subscriptionState = atom({
  key: "subscriptionState",
  default: {} as SubStatusDto
})
